/* eslint-disable no-inner-declarations */
import {resizeDebouncer} from '@pernod-ricard-global-cms/jsutils';

const TABLET_BREAKPOINT = 768;

function isTabletViewport() {
  return window.innerWidth <= TABLET_BREAKPOINT;
}

function calculateHeaderHeight(block) {
  const headerHeight = block.offsetHeight;
  const adjustedHeight = headerHeight === 0 ? 80 : headerHeight;

  document.documentElement.style.setProperty(
    '--global-site-header-height',
    `${adjustedHeight}px`
  );
}

export default function siteHeaderJs(options = {}) {
  try {
    const {block} = options;

    const $hamburger = document.getElementById('hamburger');
    const $navBar = document.getElementById('nav__bar');
    const $navMenu = document.getElementById('nav__menu');
    const $mainContainer = document.getElementById('main-container');
    const $modalMenu = document.querySelector('.modal-menu');

    if (!$navBar || !$navMenu || !$mainContainer) {
      return;
    }

    let currentViewport = isTabletViewport() ? 'mobile' : 'desktop';
    let mobileInitialised = false;
    let desktopInitialised = false;

    function isPageScrolled() {
      return window.scrollY > $navBar.parentNode.parentNode.clientHeight;
    }

    function resetSubmenus() {
      const activeSubmenus = $navMenu.querySelectorAll('.nav__submenu--active');
      const inactiveSubmenus = $navMenu.querySelectorAll('.nav__submenu--inactive');

      activeSubmenus.forEach((submenu) => {
        submenu.classList.remove('nav__submenu--active');
      });

      inactiveSubmenus.forEach((submenu) => {
        submenu.classList.remove('nav__submenu--inactive');
      });
    }

    function closeMenu() {
      resetSubmenus();

      if ($hamburger) {
        $hamburger.classList.remove('is-active');
        $hamburger.setAttribute('aria-expanded', 'false');
      }

      $mainContainer.classList.remove('main-container--active');
      $navBar.classList.remove('nav__bar--fade-in');
      $navMenu.setAttribute('class', 'nav__menu nav__menu--slide-out');
    }

    function openMenu() {
      if ($hamburger) {
        $hamburger.classList.add('is-active');
        $hamburger.setAttribute('aria-expanded', 'true');
      }

      $mainContainer.classList.add('main-container--active');
      $navBar.classList.add('nav__bar--fade-in');
      $navMenu.setAttribute('class', 'nav__menu nav__menu--slide-in');
    }

    function openClose() {
      const isOpen = $navMenu.classList.contains('nav__menu--slide-in');

      if (isOpen) {
        closeMenu();
        return;
      }

      openMenu();
    }

    function initializeMobileMenu() {
      if (mobileInitialised) {
        return;
      }

      mobileInitialised = true;

      const submenuStack = [];

      function openSubmenu(submenu) {
        submenu.classList.remove('nav__submenu--inactive');
        submenu.classList.add('nav__submenu--active');
        submenuStack.push(submenu);
      }

      function closeCurrentSubmenu() {
        const currentSubmenu = submenuStack.pop();

        if (!currentSubmenu) {
          return;
        }

        currentSubmenu.classList.add('nav__submenu--inactive');

        window.setTimeout(() => {
          currentSubmenu.classList.remove('nav__submenu--active');
          currentSubmenu.classList.remove('nav__submenu--inactive');
        }, 300);
      }

      if ($hamburger) {
        $hamburger.addEventListener('click', () => {
          if ($navMenu.classList.contains('nav__menu--slide-in')) {
            submenuStack.length = 0;
          }

          openClose();
        });
      }

      $navMenu.addEventListener('click', (event) => {
        if (!isTabletViewport()) {
          return;
        }

        const backButton = event.target.closest('.nav__back');

        if (backButton) {
          event.preventDefault();
          event.stopPropagation();
          closeCurrentSubmenu();
          return;
        }

        const clickedLink = event.target.closest('a, span');

        if (!clickedLink || !$navMenu.contains(clickedLink)) {
          return;
        }

        const parentItem = clickedLink.closest('li');
        const submenu = parentItem?.querySelector(':scope > ul');

        if (submenu) {
          event.preventDefault();
          openSubmenu(submenu);
          return;
        }

        if (clickedLink.tagName.toLowerCase() === 'a') {
          submenuStack.length = 0;
          closeMenu();
        }
      });
    }

    function initializeDesktopMenu() {
      if (desktopInitialised) {
        return;
      }

      desktopInitialised = true;

      const $navDropdown = document.querySelectorAll('.nav__dropdown');

      $navDropdown.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (isTabletViewport()) {
            return;
          }

          if ($modalMenu) {
            $modalMenu.classList.add('modal-menu--active');
          }

          $navBar.classList.add('nav__bar--fade-in-scroll');
        });

        item.addEventListener('mouseleave', () => {
          if (isTabletViewport()) {
            return;
          }

          if ($modalMenu) {
            $modalMenu.classList.remove('modal-menu--active');
          }

          if (!isPageScrolled()) {
            $navBar.classList.remove('nav__bar--fade-in-scroll');
          }
        });
      });
    }

    if (currentViewport === 'mobile') {
      initializeMobileMenu();
    } else {
      initializeDesktopMenu();
    }

    window.addEventListener('resize', () => {
      const nextViewport = isTabletViewport() ? 'mobile' : 'desktop';

      if (nextViewport === currentViewport) {
        return;
      }

      currentViewport = nextViewport;
      resetSubmenus();

      if (currentViewport === 'mobile') {
        initializeMobileMenu();
      } else {
        closeMenu();
        initializeDesktopMenu();
      }
    });

    window.addEventListener('scroll', () => {
      if (isPageScrolled()) {
        $navBar.classList.add('nav__bar--fade-in-scroll');
      } else if (!$navMenu.classList.contains('nav__menu--slide-in')) {
        $navBar.classList.remove('nav__bar--fade-in-scroll');
      }
    });

    calculateHeaderHeight(block);
    resizeDebouncer(() => calculateHeaderHeight(block), 250, true);
  } catch (error) {
    console.error(error);
  }
}